const a = '27bf34f0055c3001573745'
const b = '5d7c963fd5c0ac4eab'

export default {
  api: 'https://api.github.com/repos/Hugo-seth/blog',
  token: a + b
}


// WEBPACK FOOTER //
// ./src/libs/config.js